import { pidRegexStr } from '@fs/zion-pid'
import { generatePath, useParams } from '@fs/zion-router'
import { type GroupId } from '@fs/zion-tree-types'
import { useRouteMatch, type match } from 'react-router'
import { type PathParamMap } from './pathParamTypes'

// Constrains :groupId to valid ID format — invalid groupIds fall through to the NotFound route
export const SETTINGS_ROUTE_PATH =
  `/:subPage(research-tree)/:groupId(${pidRegexStr as GroupId})/:tab(details|latest-changes|privacy|contributors)` as const

export type TreeSettingsRouteParams = PathParamMap<typeof SETTINGS_ROUTE_PATH>

export type TabName = TreeSettingsRouteParams['tab']

export const getTabUrl = (tab: TabName, match: match<TreeSettingsRouteParams>): string =>
  generatePath(match.path, { ...match.params, tab })

export const useTreeSettingsParams = (): TreeSettingsRouteParams => {
  return useParams()
}

export const useTreeSettingsRouteMatch = (): match<TreeSettingsRouteParams> => {
  return useRouteMatch()
}
